import React, { useEffect, useRef, useState } from 'react'
import './History.scss'
import { IMG } from '../../Commons/Functions'
import ChatBox from './ChatBox'

export const HISTORY_MESSAGE_TYPE = {
    GLOBAL: "GLOBAL",
    ERROR: "ERROR"
}

export function History(props) {
    const [focusedCard, setFocusedCard] = useState(false)
    const [displayedFocusedCard, setDisplayedFocusedCard] = useState(false)
    const [scrollbarWidth, setScrollbarWidth] = useState(0);

    const containerRef = useRef(null);
    const bottomRef = useRef(null);

    useEffect(() => {
        let el = document.createElement("div");
        el.style.cssText = "overflow:scroll; visibility:hidden; position:absolute;";
        document.body.appendChild(el);
        let width = el.offsetWidth - el.clientWidth;
        el.remove();
        setScrollbarWidth(width === 0 ? 16 : width)
    }, []);

    useEffect(() => {
        if (focusedCard) {
            setDisplayedFocusedCard(focusedCard)
        }
    }, [focusedCard])

    useEffect(() => {
        const container = containerRef.current;

        const isNearBottom = () => {
            const threshold = 150; // pixels de tolérance
            return (
                container.scrollHeight - container.scrollTop - container.clientHeight < threshold
            );
        };

        if (isNearBottom()) {
            bottomRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }
    }, [props.history.length]);


    return (
        <div className="history position-fixed end-0 bottom-0">
            <div className='background position-absolute top-0 start-0 w-100 h-100'></div>
            <div className='blur position-absolute top-0 start-0 w-100 h-100'></div>
            <div ref={containerRef} className='content position-absolute top-0 start-0 w-100 h-100 overflow-y-scroll overflow-x-hidden'>
                {props.history.map((h, i) => {
                    return (<HistoryMessage content={h} key={i} setFocusedCard={setFocusedCard} playerId={props.playerId} />)
                })}
                <div ref={bottomRef} className='chat-bottom' />
            </div>
            <div className="chat-fade-mask" />
            {displayedFocusedCard && (<div style={{ visibility: focusedCard ? "visible" : "hidden" }} className={'history-focused-card pe-none position-absolute' + (displayedFocusedCard.cardData.face.front.isHorizontal ? " horizontal" : "")}>
                <IMG className="w-100 h-100" src={displayedFocusedCard.cardData.face.front.image} />
            </div>)}
            <ChatBox sendToHistory={props.sendToHistory} setIsTextInputFocused={props.setIsTextInputFocused} scrollbarWidth={scrollbarWidth} />
        </div>
    )
}

export default React.memo(History)

function HistoryMessage(props) {
    if (props.content.type == HISTORY_MESSAGE_TYPE.ERROR) {
        return (<div className='full-width error'>
            <p>{props.content.text}</p>
        </div>)
    }

    if (props.content.type == HISTORY_MESSAGE_TYPE.GLOBAL) {
        return (<div className='full-width'>
            <p>{props.content.text}</p>
        </div>)
    }

    if (props.content.card) {
        if (props.content.card.hiddenTo[props.playerId]) {
            return (<div>
                <h5>{props.content.player}</h5>
                <p className='text-start'>{props.content.text} a card</p>
            </div>)
        } else {
            return (<div>
                <h5>{props.content.player}</h5>
                <p className='text-start'>{props.content.text} <CardName card={props.content.card} setFocusedCard={props.setFocusedCard} /></p>
            </div>)
        }
    }

    return (<div>
        <h5>{props.content.player}</h5>
        <p className='text-start'>{props.content.text}</p>
    </div>)
}

function CardName(props) {
    let data = props.card.cardData
    return (<b className="history-card-name"
        onPointerEnter={() => props.setFocusedCard(props.card)}
        onPointerLeave={() => props.setFocusedCard(false)}
    >{data.name}</b>)
}